import { DailyVideo } from '@daily-co/daily-react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';
import { transientProps } from '../../utils/transientProps';

export const VideoWrapper = styled(Stack)`
  width: 100%;
  justify-content: center;
  align-items: center;

  & > div {
    position: relative;
  }

  video {
    width: 100%;
  }
`;

export const ScreenDailyVideo = styled(DailyVideo, transientProps)<{ $isScreenShareOn: boolean }>`
  border-radius: ${tokens.radius.l};
  ${({ $isScreenShareOn }) =>
    !$isScreenShareOn &&
    css`
      display: none;
    `}
`;

export const CameraDailyVideo = styled(DailyVideo, transientProps)<{ $isScreenShareOn: boolean }>`
  border-radius: ${tokens.radius.l};
  ${({ $isScreenShareOn }) =>
    $isScreenShareOn &&
    css`
      max-width: 25%;
      position: absolute;
      bottom: ${tokens.spacer.x2};
      right: ${tokens.spacer.x2};
      border-radius: ${tokens.radius.m};
    `}
`;
